<p-toast key="tst" [style]="{marginTop: '70px'}"></p-toast>

<!-- USER CARD -->
<section class="validateUser">

    <!-- FORM VALIDATION -->
    <form *ngIf="!isValid" class="card p-fluid p-col-12 p-md-6  ui-g ui-fluid top-buffer validateUserForm"
        [formGroup]="validateUserForm">

        <div class="p-d-flex p-flex-row p-col-4" *ngIf="device != '2'">
            <div class="ui-xl-2 ui-lg-3 ui-md-3 ui-g-3">
                <button pButton class="button-back" pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2" (click)="goBack()"></button>
            </div>
        </div>

        <h4 class="validateUserForm__title" *ngIf="device != '2'">{{lbl_validate}} {{lbl_user}}</h4><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-google"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="1" formControlName="currentEmail" type="email" aria-describedby="current-help"
                            pInputText />
                        <label htmlFor="currentEmailInput">{{lbl_entry}} {{lbl_email}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="validateUserForm.controls['currentEmail'].invalid && (validateUserForm.controls['currentEmail'].dirty || validateUserForm.controls['currentEmail'].touched)"
                    class="alert">
                    <div *ngIf="validateUserForm.controls['currentEmail'].errors.required">
                        <p-message severity="error" text="Correo Electrónico requerido"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentEmail'].errors.pattern">
                        <p-message severity="error" text="Correo Electrónico formato invalido"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentEmail'].hasError('maxlength')">
                        <p-message severity="error" text="Correo Electrónico excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentEmail'].hasError('minlength')">
                        <p-message severity="error" text="Correo Electrónico infiere formato longitud"></p-message>
                    </div>
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-id-card"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="2" id="currentCertifiedInput" formControlName="currentCertified"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentCertifiedInput">{{lbl_entry}} {{lbl_certificate}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="validateUserForm.controls['currentCertified'].invalid && (validateUserForm.controls['currentCertified'].dirty || validateUserForm.controls['currentCertified'].touched)"
                    class="alert">
                    <div *ngIf="validateUserForm.controls['currentCertified'].errors.pattern">
                        <p-message severity="error" text="Certificado ó télefono formato invalido"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentCertified'].hasError('maxlength')">
                        <p-message severity="error" text="Certificado ó télefono excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentCertified'].hasError('minlength')">
                        <p-message severity="error" text="Certificado ó télefono infiere formato longitud"></p-message>
                    </div>
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
                    <span class="p-float-label">
                        <input tabIndex="3" id="currentIdGuideInput" formControlName="currentIdGuide"
                            aria-describedby="current-help" pInputText />
                        <label htmlFor="currentIdGuideInput">{{lbl_entry}} {{lbl_id}} {{lbl_guide}}</label>
                    </span>
                </div>
                <!--
                <div *ngIf="validateUserForm.controls['currentIdGuide'].invalid && (validateUserForm.controls['currentIdGuide'].dirty || validateUserForm.controls['currentIdGuide'].touched)"
                    class="alert">
                    <div *ngIf="validateUserForm.controls['currentIdGuide'].errors.pattern">
                        <p-message severity="error" text="ID Guía SANTOV formato invalido"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentIdGuide'].hasError('maxlength')">
                        <p-message severity="error" text="ID Guía SANTOV excede formato longitud"></p-message>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentIdGuide'].hasError('minlength')">
                        <p-message severity="error" text="ID Guía SANTOV infiere formato longitud"></p-message>
                    </div>
                </div>
                -->
            </div>
        </fieldset><br />

        <!-- INPUT BUTTON -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label">
                <button tabIndex="4" pButton pRipple type="button" icon="pi pi-check" label="{{lbl_validate}}"
                    class="p-button-raised p-button-success" (keyup.enter)="confirmvalidateUser($event)"
                    (click)="confirmvalidateUser($event)"></button>
            </div>
        </fieldset>

        <!-- LEGENDS -->
        <fieldset class="ui-xl-4 ui-lg-4 ui-md-12 ui-g-12">
            <div class="ui-float-label" style="font-size: 1.1em; line-height: 1.5;">
                <legend><strong>{{lbl_for + ' ' + lbl_future_guide}} :</strong>{{ ' ' + lbl_entry}} <span
                        style="color: #28a745; font-weight: bold;">{{ ' ' + lbl_guide}} </span> {{ ' ' + lbl_and}} <span
                        style="color: #28a745; font-weight: bold;">{{ ' ' + lbl_email}} </span>.</legend>
                <legend><strong>{{lbl_for + ' ' + lbl_guide}} :</strong>{{ ' ' + lbl_entry}} <span
                        style="color: #28a745; font-weight: bold;">{{ ' ' + lbl_certificate}} </span> {{ ' ' + lbl_and}}
                    <span style="color: #28a745; font-weight: bold;">{{ ' ' + lbl_email}} </span>.
                </legend>
            </div>
        </fieldset>

        <br />
    </form>

    <!-- FORM REGISTER -->
    <div *ngIf="isValid" class="card p-col-12 p-m-2">
        <h5 class="validateUserForm__title--normal">Crear Usuario</h5>
        <form [formGroup]="validateUserForm" class=" p-fluid p-formgrid p-grid">

            <div class="p-col-12 p-md-6">
                <!-- Input EMAIL-->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-google"></i>
                        </span>
                        <span class="p-float-label">
                            <input disabled tabIndex="1" id="currentEmailInput" formControlName="currentEmail"
                                type="email" aria-describedby="current-help" pInputText />
                            <label htmlFor="currentEmailInput">{{lbl_email}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentEmail'].invalid && (validateUserForm.controls['currentEmail'].dirty || validateUserForm.controls['currentEmail'].touched)"
                        class="alert">
                        <div *ngIf="validateUserForm.controls['currentEmail'].errors.required">
                            <p-message severity="error" text="Contraseña requerido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentEmail'].errors.pattern">
                            <p-message severity="error" text="Contraseña formato invalido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentEmail'].hasError('maxlength')">
                            <p-message severity="error" text="Contraseña excede formato longitud"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentEmail'].hasError('minlength')">
                            <p-message severity="error" text="Contraseña infiere formato longitud"></p-message>
                        </div>
                    </div>
                </div>

                <!-- Input CERTIFIED -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-id-card"></i>
                        </span>
                        <span class="p-float-label">
                            <input disabled tabIndex="2" id="currentCertifiedInput" formControlName="currentCertified"
                                type="email" aria-describedby="current-help" pInputText />
                            <label htmlFor="currentCertifiedInput">{{lbl_certificate}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentCertified'].invalid && (validateUserForm.controls['currentCertified'].dirty || validateUserForm.controls['currentCertified'].touched)"
                        class="alert">
                        <div *ngIf="validateUserForm.controls['currentCertified'].errors.required">
                            <p-message severity="error" text="Certificado ó télefono requerido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentCertified'].errors.pattern">
                            <p-message severity="error" text="Certificado ó télefono formato invalido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentCertified'].hasError('maxlength')">
                            <p-message severity="error"
                                text="Certificado ó télefono excede formato longitud"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentCertified'].hasError('minlength')">
                            <p-message severity="error"
                                text="Certificado ó télefono infiere formato longitud"></p-message>
                        </div>
                    </div>
                </div>

                <!-- Input ID GUIDE-->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-user"></i>
                        </span>
                        <span class="p-float-label">
                            <input disabled tabIndex="3" id="currentIdGuideInput" formControlName="currentIdGuide"
                                type="email" aria-describedby="current-help" pInputText />
                            <label htmlFor="currentIdGuideInput">{{lbl_id}} {{lbl_guide}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['currentIdGuide'].invalid && (validateUserForm.controls['currentIdGuide'].dirty || validateUserForm.controls['currentIdGuide'].touched)"
                        class="alert">
                        <div *ngIf="validateUserForm.controls['currentIdGuide'].errors.required">
                            <p-message severity="error" text="ID Guía SANTOV requerido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentIdGuide'].errors.pattern">
                            <p-message severity="error" text="ID Guía SANTOV formato invalido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentIdGuide'].hasError('maxlength')">
                            <p-message severity="error" text="ID Guía SANTOV excede formato longitud"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['currentIdGuide'].hasError('minlength')">
                            <p-message severity="error" text="ID Guía SANTOV infiere formato longitud"></p-message>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12 p-md-6 ">

                <!-- Input USERNAME -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-pencil"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="4" id="nameInput" formControlName="name" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="nameInput">{{lbl_id}} {{lbl_user}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['name'].invalid && (validateUserForm.controls['name'].dirty || validateUserForm.controls['name'].touched)"
                        class="alert">
                        <div *ngIf="validateUserForm.controls['name'].errors.required">
                            <p-message severity="error" text="Nombre requerido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['name'].errors.pattern">
                            <p-message severity="error" text="Nombre formato invalido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['name'].hasError('maxlength')">
                            <p-message severity="error" text="Nombre excede formato longitud"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['name'].hasError('minlength')">
                            <p-message severity="error" text="Nombre infiere formato longitud"></p-message>
                        </div>
                    </div>
                </div>

                <!-- Input PASSWORD -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-key">
                            </i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="5" id="passwordInput" formControlName="password" type="password"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="passwordInput">{{lbl_password}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['password'].invalid && (validateUserForm.controls['password'].dirty || validateUserForm.controls['password'].touched)"
                        class="alert">
                        <div *ngIf="validateUserForm.controls['password'].errors.required">
                            <p-message severity="error" text="{{lbl_entry}} {{lbl_password}}"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['password'].errors.pattern">
                            <p-message severity="error" text="Contraseña formato invalido"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['password'].hasError('maxlength')">
                            <p-message severity="error" text="Contraseña excede formato longitud"></p-message>
                        </div>
                        <div *ngIf="validateUserForm.controls['password'].hasError('minlength')">
                            <p-message severity="error" text="Contraseña infiere formato longitud"></p-message>
                        </div>
                    </div>
                </div>

                <!-- Input CONFIRM PASSWORD -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-key"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="6" id="confirmPasswordInput" formControlName="confirmPassword"
                                type="password" aria-describedby="current-help" pInputText />
                            <label htmlFor="confirmPasswordInput">{{lbl_confirm}} {{lbl_password}}</label>
                        </span>
                    </div>
                    <div *ngIf="validateUserForm.controls['confirmPassword'].invalid && (validateUserForm.controls['confirmPassword'].dirty || validateUserForm.controls['confirmPassword'].touched)"
                        class="alert">

                        <div
                            *ngIf="validateUserForm.controls['confirmPassword'].value != validateUserForm.controls['password'].value">
                            <p-message severity="error" text="{{lbl_password}} {{lbl_does_not_match}}"></p-message>
                        </div>
                    </div>
                </div>


            </div>

            <!-- Space  -->
            <div class="p-field p-col-12 p-md-4"></div>

            <!-- Button -->


            <div class="p-field p-col-12 p-md-4">
                <div class="ui-float-label">
                    <button [disabled]="button_save" tabIndex="7" pButton pRipple type="button" icon="pi pi-check"
                        label="{{lbl_accept}}" class="p-button-raised p-button-success"
                        (keyup.enter)="confirmCreateUser($event)" (click)="confirmCreateUser($event)"></button>
                </div>
            </div>
        </form>
    </div>

</section>